import React, { Component } from 'react';
import { connect } from 'react-redux'
import Input from "../dig-components/input";
import Well from '../dig-components/well';
import { Flex } from '@m/alchemy-ui/Flex';
import hostingElementChanged from "../../actions/embeddedFormActions";

export class EmbeddedFormsPane extends Component {
  onPropertyChanged(propertName, value) {
    const newElement = {};
    newElement[propertName] = value;
    const newHostingElement = Object.assign(
      {},
      this.props.hostingElement,
      newElement
    );
    this.props.onHostingElementChanged(newHostingElement);
  }

  render() {
    var paneObject = this;
    return (
      <div>
        <Flex direction="column" alignItems="normal">
          <label>Embedded Form Container Size</label>
          <Well>
            <Input
              label="Width"
              id="width"
              type="number"
              value={this.props.hostingElement.width}
              onChange={newValue =>
                paneObject.onPropertyChanged('width', newValue)
              }
            />
            <Input
              label="Min Height"
              id="minheight"
              type="number"
              value={this.props.hostingElement.minHeight}
              onChange={newValue =>
                paneObject.onPropertyChanged('minHeight', newValue)
              }
            />
            <Input
              label="Max Height"
              id="maxheight"
              type="number"
              value={this.props.hostingElement.maxHeight}
              onChange={newValue =>
                paneObject.onPropertyChanged('maxHeight', newValue)
              }
            />
          </Well>
        </Flex>
        <div className="dig-section-break" />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onHostingElementChanged: newHostingElement => {
      dispatch(hostingElementChanged(newHostingElement));
    },
  };
};

function mapStateToProps(state) {
  return {
    hostingElement: state.hostingElement
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(EmbeddedFormsPane);
